import { useFormikContext } from 'formik';
import { FC } from 'react';
import { useEffect } from 'react';
import { useCallback } from 'react';
import { useQueryParams } from '../hooks/useQueryParams';

interface Props {
    state: any;
    emptyFilterState: any;
    setLoading: (value: boolean) => void;
}
export const FormQueryParams: FC<Props> = ({
    state,
    emptyFilterState,
    setLoading,
}) => {
    const { setValues, submitCount } = useFormikContext();

    const resetForm = useCallback(() => {
        setValues(emptyFilterState);
    }, [emptyFilterState, setValues]);

    const isLoading = useQueryParams({
        state,
        submitCounter: submitCount,
        autoScroll: false,
        resetForm,
    });

    useEffect(() => {
        setLoading(isLoading);
    }, [isLoading, setLoading]);

    return null;
};
